// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateUruguayanDocument } from './uruguayan-document';
import { validateUruguayanPhoneNumber } from './uruguayan-phone-number';
import { validateUruguayanZipcode } from './uruguayan-zipcode';
import { validateUruguayanState } from './uruguayan-state';
import { validateUruguayanCity } from './uruguayan-city';
import { validateUruguayanAddress } from './uruguayan-address';
import { validateUruguayanStreetNumber } from './uruguayan-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'uruguayanDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_uruguayan_document') && validateUruguayanDocument(userInputValue);
      }
      return null;

    case 'uruguayanPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_uruguayan_phone_number') && validateUruguayanPhoneNumber(userInputValue);
      }
      return null;

    case 'uruguayanZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_uruguayan_zipcode') && validateUruguayanZipcode(userInputValue);
      }
      return null;

    case 'uruguayanState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_uruguayan_state') && validateUruguayanState(userInputValue);
      }
      return null;

    case 'uruguayanCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_uruguayan_city') && validateUruguayanCity(userInputValue);
      }
      return null;

    case 'uruguayanAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_uruguayan_address') && validateUruguayanAddress(userInputValue);
      }
      return null;

    case 'uruguayanStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_uruguayan_street_number') && validateUruguayanStreetNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
